import { Box, Button, Chip, CircularProgress, IconButton } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'

export const ASPEN_RECEIVE_ITEMS_STATUS = {
  processing: { label: 'Sync in progress…', color: 'warning' },
  success: { label: 'Successful', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
}

export const formatAspenReceiveItemsResponse = (payload) => {
  if (payload == null || payload === '') return 'No response body was stored.'
  if (typeof payload === 'string') return payload
  try {
    return JSON.stringify(payload, null, 2)
  } catch {
    return String(payload)
  }
}

export const aspenReceiveItemsViewBody = (stored) => {
  if (!stored) return null
  if (stored.response != null) return stored.response
  return stored.error || null
}

/** Retry is only offered after a stored failure, and never while a click is in flight. */
export const canShowAspenReceiveRetry = ({ status, isSuperuser }) =>
  Boolean(isSuperuser && status === 'failed')

export default function AspenReceiveItemsStatus({
  status,
  response,
  shipmentLabel,
  isSuperuser,
  retrying,
  onRetry,
  onView,
  onRequestView,
  viewLoading = false,
}) {
  const meta = ASPEN_RECEIVE_ITEMS_STATUS[status]
  if (!meta) return null
  const showRetry = canShowAspenReceiveRetry({ status, isSuperuser })
  const viewBody = aspenReceiveItemsViewBody(response)
  const canView = onRequestView
    ? status !== 'processing'
    : viewBody != null && status !== 'processing'
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.75, flexWrap: 'wrap' }}>
      <Chip size="small" label={`Shwapno Receive Item · ${meta.label}`} color={meta.color} />
      {canView ? (
        <IconButton
          size="small"
          aria-label="View Shwapno receive item response"
          disabled={viewLoading}
          onClick={() => {
            if (onRequestView) onRequestView()
            else {
              onView({
                heading: `${shipmentLabel} Shwapno Receive Item`,
                response: viewBody,
              })
            }
          }}
        >
          {viewLoading ? <CircularProgress size={16} /> : <VisibilityIcon fontSize="small" />}
        </IconButton>
      ) : null}
      {showRetry ? (
        <Button
          size="small"
          variant="outlined"
          disabled={retrying}
          onClick={onRetry}
        >
          {retrying ? 'Retrying…' : 'Retry'}
        </Button>
      ) : null}
    </Box>
  )
}
